import { FC, RefObject, useEffect, useState } from 'react';
import { useOrientation } from '@/hooks/useOrientation';
import { useIsMobile } from '@keyslabor/shared/hooks/useBreakPoint.ts';
import ModalConfirm from '@keyslabor/shared/ui/ModalConfirm';
import { Box, Button } from '@keyslabor/shared/ui';
import { useTranslation } from 'react-i18next';

const RestrictionIcon = () => (
  <svg
    width="144"
    height="132"
    viewBox="0 0 144 132"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_13680_3741"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="7"
      width="125"
      height="125"
    >
      <rect y="7.00001" width="125" height="125" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_13680_3741)">
      <path
        d="M80.4681 76.7917C79.9473 81.3924 77.9941 85.2335 74.6087 88.3151C71.2233 91.3967 67.1868 92.9375 62.4993 92.9375C61.8049 92.9375 61.1105 92.8941 60.416 92.8073C59.7216 92.7205 59.0271 92.5903 58.3327 92.4167C57.6382 92.2431 56.9004 92.2431 56.1191 92.4167C55.3379 92.5903 54.6868 92.9375 54.166 93.4583C53.2112 94.4132 52.8639 95.5634 53.1243 96.9089C53.3848 98.2543 54.1226 99.1441 55.3379 99.5781C56.5532 100.012 57.7467 100.316 58.9186 100.49C60.0905 100.663 61.2841 100.75 62.4993 100.75C69.357 100.75 75.2598 98.428 80.2077 93.7839C85.1556 89.1398 87.8466 83.3889 88.2806 76.5313L89.4525 77.5729C90.2337 78.2674 91.1452 78.6146 92.1868 78.6146C93.2285 78.6146 94.0966 78.2674 94.791 77.5729C95.5723 76.7917 95.9846 75.8585 96.028 74.7734C96.0714 73.6884 95.7025 72.7552 94.9212 71.974L88.2806 65.3333C87.3257 64.3785 86.1105 63.901 84.6348 63.901C83.1591 63.901 81.9438 64.3785 80.9889 65.3333L74.3483 71.974C73.5671 72.7552 73.1764 73.6667 73.1764 74.7083C73.1764 75.75 73.5671 76.6615 74.3483 77.4427C75.1296 78.224 76.041 78.6146 77.0827 78.6146C78.1243 78.6146 79.0358 78.224 79.8171 77.4427L80.4681 76.7917ZM36.7181 72.8854L35.5462 71.8438C34.765 71.1493 33.8535 70.8021 32.8118 70.8021C31.7702 70.8021 30.9021 71.1493 30.2077 71.8438C29.4264 72.625 29.0141 73.5582 28.9707 74.6432C28.9273 75.7283 29.2962 76.6615 30.0775 77.4427L36.7181 84.0833C37.673 85.0382 38.8882 85.5156 40.3639 85.5156C41.8396 85.5156 43.0549 85.0382 44.0098 84.0833L50.6504 77.4427C51.4316 76.6615 51.8223 75.75 51.8223 74.7083C51.8223 73.6667 51.4316 72.7552 50.6504 71.974C49.8691 71.1927 48.9577 70.8021 47.916 70.8021C46.8743 70.8021 45.9629 71.1927 45.1816 71.974L44.5306 72.625C45.0514 68.0243 47.0046 64.1832 50.39 61.1016C53.7754 58.02 57.8118 56.4792 62.4993 56.4792C63.1938 56.4792 63.8882 56.5226 64.5827 56.6094C65.2771 56.6962 65.9716 56.8264 66.666 57C67.3605 57.1736 68.0983 57.1736 68.8796 57C69.6608 56.8264 70.3118 56.4792 70.8327 55.9583C71.7875 55.0035 72.1348 53.8533 71.8743 52.5078C71.6139 51.1623 70.8761 50.2726 69.6608 49.8385C68.4455 49.4045 67.2519 49.1007 66.0801 48.9271C64.9082 48.7535 63.7146 48.6667 62.4993 48.6667C55.6417 48.6667 49.7389 50.9887 44.791 55.6328C39.8431 60.2769 37.1521 66.0278 36.7181 72.8854ZM20.8327 116.375C17.9681 116.375 15.5158 115.355 13.4759 113.315C11.436 111.275 10.416 108.823 10.416 105.958V43.4583C10.416 40.5938 11.436 38.1415 13.4759 36.1016C15.5158 34.0616 17.9681 33.0417 20.8327 33.0417H37.2389L43.7493 26.0104C44.7042 24.9688 45.8544 24.1441 47.1999 23.5365C48.5454 22.9288 49.9559 22.625 51.4316 22.625H73.5671C75.0427 22.625 76.4533 22.9288 77.7988 23.5365C79.1443 24.1441 80.2945 24.9688 81.2493 26.0104L87.7598 33.0417H104.166C107.031 33.0417 109.483 34.0616 111.523 36.1016C113.563 38.1415 114.583 40.5938 114.583 43.4583V105.958C114.583 108.823 113.563 111.275 111.523 113.315C109.483 115.355 107.031 116.375 104.166 116.375H20.8327ZM20.8327 105.958H104.166V43.4583H83.0723L73.5671 33.0417H51.4316L41.9264 43.4583H20.8327V105.958Z"
        fill="currentColor"
      />
    </g>
    <mask
      id="mask1_13680_3741"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="90"
      y="0"
      width="54"
      height="54"
    >
      <rect x="90" y="3.8147e-05" width="54" height="54" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask1_13680_3741)">
      <path
        d="M117 38.25C117.638 38.25 118.172 38.0344 118.603 37.6032C119.034 37.1719 119.25 36.6375 119.25 36C119.25 35.3625 119.034 34.8282 118.603 34.3969C118.172 33.9657 117.638 33.75 117 33.75C116.362 33.75 115.828 33.9657 115.397 34.3969C114.966 34.8282 114.75 35.3625 114.75 36C114.75 36.6375 114.966 37.1719 115.397 37.6032C115.828 38.0344 116.362 38.25 117 38.25ZM117 29.25C117.638 29.25 118.172 29.0344 118.603 28.6032C119.034 28.1719 119.25 27.6375 119.25 27V18C119.25 17.3625 119.034 16.8282 118.603 16.3969C118.172 15.9657 117.638 15.75 117 15.75C116.362 15.75 115.828 15.9657 115.397 16.3969C114.966 16.8282 114.75 17.3625 114.75 18V27C114.75 27.6375 114.966 28.1719 115.397 28.6032C115.828 29.0344 116.362 29.25 117 29.25ZM117 49.5C113.888 49.5 110.962 48.9094 108.225 47.7282C105.487 46.5469 103.106 44.9438 101.081 42.9188C99.0562 40.8938 97.4531 38.5125 96.2719 35.775C95.0906 33.0375 94.5 30.1125 94.5 27C94.5 23.8875 95.0906 20.9625 96.2719 18.225C97.4531 15.4875 99.0562 13.1063 101.081 11.0813C103.106 9.05629 105.487 7.45316 108.225 6.27191C110.962 5.09066 113.888 4.50004 117 4.50004C120.112 4.50004 123.038 5.09066 125.775 6.27191C128.513 7.45316 130.894 9.05629 132.919 11.0813C134.944 13.1063 136.547 15.4875 137.728 18.225C138.909 20.9625 139.5 23.8875 139.5 27C139.5 30.1125 138.909 33.0375 137.728 35.775C136.547 38.5125 134.944 40.8938 132.919 42.9188C130.894 44.9438 128.513 46.5469 125.775 47.7282C123.038 48.9094 120.112 49.5 117 49.5Z"
        fill="#FE4C4C"
      />
    </g>
  </svg>
);

export const DesktopRecordBlock = () => {
  const isMobile = useIsMobile();

  if (!isMobile) {
    return (
      <ModalConfirm
        key="desctopRecordBlock"
        show
        drawer={false}
        customDesktopWidth={'auto'}
      >
        <Box color={'#143980'}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="144"
            height="144"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="m14.5 12.5-5-5" />
            <path d="m9.5 12.5 5-5" />
            <rect width="20" height="14" x="2" y="3" rx="2" />
            <path d="M12 17v4" />
            <path d="M8 21h8" />
          </svg>
        </Box>
        <Box
          css={`
            margin-top: 10px;
            font-size: 16px;
            font-weight: 600;
            max-width: 335px;
            text-align: center;
          `}
        >
          This interview system is designed for mobile access only.
          <br />
          We apologize for any inconvenience. Please use the same link to open
          the interview on your cellphone.
        </Box>
      </ModalConfirm>
    );
  }

  return null;
};

export const LandscapeBlock: FC<{ onRecordDisable: () => void }> = ({
  onRecordDisable,
}) => {
  const orientation = useOrientation();
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!orientation.type.startsWith('portrait')) {
      onRecordDisable();
    }
  }, [orientation.type, onRecordDisable]);

  if (orientation.type.startsWith('portrait')) return null;

  if (!isMobile) {
    return <DesktopRecordBlock />;
  }

  return (
    <Box
      css={`
        position: fixed;
        inset: 0;
        z-index: 1000;
        background: rgba(29, 29, 29, 0.99);
        display: grid;
        place-content: center;
        justify-items: center;
        color: white;
      `}
    >
      <RestrictionIcon />
      <Box
        css={`
          margin-top: 10px;
          font-weight: 600;
        `}
      >
        Return the screen to vertical position
      </Box>
    </Box>
  );
};

export const ScreenLockBlock: FC<{
  mediaRecordRef: RefObject<MediaRecorder>;
  onContinueClick: () => void;
}> = ({ mediaRecordRef, onContinueClick }) => {
  const { t } = useTranslation();
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        if (
          mediaRecordRef.current &&
          mediaRecordRef.current.state === 'recording'
        ) {
          mediaRecordRef.current.pause(); // or stop()
          setIsError(true);
        }
      } else if (
        document.visibilityState === 'visible' &&
        mediaRecordRef.current
      ) {
        mediaRecordRef.current.resume();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  if (!isError) return null;

  return (
    <Box
      css={`
        position: fixed;
        inset: 0;
        z-index: 1000;
        background: rgba(29, 29, 29, 0.99);
        display: grid;
        place-content: center;
        justify-items: center;
        color: white;
      `}
    >
      <Box
        css={`
          margin-top: 10px;
          font-weight: 600;
          text-align: center;
        `}
        px={'32px'}
      >
        {t('lock_screen_popup.text')}
      </Box>
      <div>
        <Button
          mt="60px"
          maxWidth="332px"
          kind="large"
          onClick={() => {
            onContinueClick();
            setIsError(false); // reset error state
          }}
        >
          {t('lock_screen_popup.button_label')}
        </Button>
      </div>
    </Box>
  );
};

export default LandscapeBlock;
